
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("f2JIn", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $cd835511666c2fb9$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Danish (Denmark)
var $cd835511666c2fb9$export$2e2bcd8739ae039 = {
    'confluence-analytics-chart.default-loading-text': "Opdaterer analysedata\xa0\u2026",
    'confluence-analytics-chart.tooltip.no-views-data': 'Ingen data',
    'confluence-analytics-chart.tooltip.views-overall': '{count, plural, one {1 visning} other {{count} visninger}}',
    'confluence-analytics-chart.tooltip.views-today-so-far': '{count, plural, one {1 visning indtil videre} other {{count} visninger indtil videre}}',
    'confuence-analytics-chart.accessible-table.caption': 'Sidevisninger',
    'confuence-analytics-chart.accessible-table.header.date': 'Dato',
    'confuence-analytics-chart.accessible-table.header.view-count': 'Visninger',
    'confuence-analytics-chart.accessible-table.no-view-count-data': 'Ingen visninger'
};

});


//# sourceMappingURL=da.15aad747.js.map
